import { StepValidationResult } from 'features/libra/workflow/workflowStepsApi'
import { GeckoAssetModel } from 'types'

interface ComputeFfsAssetModelValidationArgs {
  unitId: string | undefined
  componentId: string | undefined
  assetModel: GeckoAssetModel | undefined
}

interface ComputeFfsAssetModelValidationResult {
  validation: StepValidationResult
  isComponentInAssetModel: boolean
}

/**
 * Validates that an asset_model exists for the unit AND it contains the
 * ticket's component in its components map.
 *
 * Pure function over inputs supplied by the caller. The asset model itself
 * is fetched once by `useFfsTicketContext`; the caller passes it in here.
 * The step component wraps this call in `useMemo` so React only recomputes
 * when an input changes.
 */
export function computeFfsAssetModelValidation({
  unitId,
  componentId,
  assetModel,
}: ComputeFfsAssetModelValidationArgs): ComputeFfsAssetModelValidationResult {
  const isComponentInAssetModel = Boolean(
    assetModel && componentId && assetModel.data.components.has(componentId)
  )

  let validation: StepValidationResult = undefined
  if (!unitId || !componentId) {
    validation = {
      status: 'Error',
      message: 'Ticket is missing required unit/component tags.',
    }
  } else if (!assetModel) {
    validation = {
      status: 'Error',
      message:
        'No asset model exists for this unit yet. Create one via the unit details page, then return to this workflow.',
    }
  } else if (!isComponentInAssetModel) {
    validation = {
      status: 'Error',
      message:
        'The ticket component is not yet in the asset model. Pick a component type below to add it.',
    }
  }

  return { validation, isComponentInAssetModel }
}
